import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../input/input.component';
import { ButtonComponent } from '../button/button.component';
import { CommonService } from '../../services/common.service';
import { InputCheckboxComponent } from "../input-checkbox/input-checkbox.component";
import { InputPhoneComponent } from '../input-phone/input-phone.component';
import { MatDialog } from '@angular/material/dialog';
import { EmailVerificationModalComponent } from '../email-verification-modal/email-verification-modal.component';
import { TrackingService } from '../../services/tracking.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, InputComponent, InputCheckboxComponent, InputPhoneComponent,ButtonComponent, InputCheckboxComponent, TranslateModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  phoneForm = new FormGroup({
    phone: new FormControl(null,[Validators.required]),
  })


  registerForm = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(40),
      Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+ [a-zA-ZáéíóúÁÉÍÓÚñÑ]+$')
    ]),
    email: new FormControl('',[Validators.required, Validators.email]),
    phone: new FormControl('',[Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required]),
    acceptTerms: new FormControl(false)
  })

  isLoading = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService,
    private dialog: MatDialog,
    private trackingService: TrackingService
  ) {}

  ngOnInit() {
    this.registerForm.get('password')?.valueChanges.subscribe(() => {
      this.commonService.checkPasswords(this.registerForm)
    });
    this.registerForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.commonService.checkPasswords(this.registerForm)
    });
  }

  onSubmit() {
    if(this.phoneForm.valid){
      const phoneObject = this.phoneForm.get('phone')?.value
      if(phoneObject){
        this.registerForm.get('phone')?.patchValue(phoneObject['e164Number']);
      }else{
        this.registerForm.get('phone')?.patchValue(null);
      }
    }else{
      this.registerForm.get('phone')?.patchValue(null);
    }
    this.checkAcceptedTerms()

    
    this.registerForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.registerForm)

    this.phoneForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.phoneForm)

    if (this.registerForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      const { name, email, password, phone } = this.registerForm.value;
      // const { name, email, password } = this.registerForm.value;

      if(!name || !email || !password || !phone) {
        this.isLoading = false;
        this.errorMessage = 'Por favor, completa todos los campos.';
        return 
      }

      this.authService.register(name, email, password, phone).subscribe(
        (response) => {
          this.isLoading = false;

          this.trackingService.track('CompleteRegistration', {
            content_name: 'new_user_registration',
            status: 'success',
            content_type: 'user'
          });

          this.registerForm.reset();
          this.phoneForm.reset();
          this.errorMessage = '';

          this.openVerificationModal(email)
        },
        (error) => {
          console.error('Error durante el registro:', error);
          this.isLoading = false;
          this.errorMessage = error.error.message ?? 'Error al registrar. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }


    openVerificationModal(email:string) {
      const dialogRef = this.dialog.open(EmailVerificationModalComponent, {
        data: {
          email: email
        },
        panelClass: 'custom-modal-container',
        backdropClass: 'custom-modal-backdrop',
        disableClose: false,
        maxWidth: '90vw',
        width: '480px'
      });
    }


  checkAcceptedTerms(): void {
    const group = this.registerForm
    const acceptTerms = group.get('acceptTerms');
  
    if (acceptTerms) {
      const accepted = acceptTerms.value;
 
      if (!accepted) {
        acceptTerms.setErrors({ acceptTerms: true });
      }
    }
  }

  checkPasswords(): void {
    const group = this.registerForm
    const passwordControl = group.get('password');
    const confirmPasswordControl = group.get('confirmPassword');
  
    if (passwordControl && confirmPasswordControl) {
      const pass = passwordControl.value;
      const confirmPass = confirmPasswordControl.value;
  
      if (pass !== confirmPass) {
        confirmPasswordControl.setErrors({ notSame: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }
}

